import ctxsNative from '../ctxsNative';
import AuthMan from '../AuthMan';
import { Logger } from '../Logger';
import { AotCategory, logConstants } from '../../utils/Constants';
import Utils from '../../utils/Utils';
import { OpenLoginUrlParams } from '../main';
import { getOIDCRedirectURI, stringConstants } from '../AuthConstants';
import { config } from '../AuthConfig';

const authWebviewHandler = {
	//Opens the Auth Webview for authentication (if another request is not already being processed)
	//TODO-LLT: "authwebview" param rename to "dsauthContext"/"oidcContext"
	async start(
		startUrl: string,
		referenceUri: string,
		id: string,
		webviewType: string,
		transactionId: string,
		isGatewayStore = false
	): Promise<string> {
		const authMan = AuthMan.getInstance();
		const urlToLog = Utils.getInstance().removeQueryStringAndHashFromUrl(startUrl);
		Logger.getInstance().write(
			logConstants.INFO,
			id + ': opening webview for startUrl: ' + urlToLog,
			AotCategory.Info,
			'Showing login page'
		);
		return new Promise(
			function (resolve: Function, reject: Function): void {
				const request = authMan.requestQueue.find((req) => req.id === id);
				request.webviewResolve = resolve;
				request.reject = reject;

				if (Utils.getInstance().isBridgeFunctionSupported(ctxsNative, 'openLoginUrl')) {
					const params: OpenLoginUrlParams = {
						startUrl,
						referenceUri,
						webviewType,
						cookies: '',
						transactionId,
						id,
						exitMode:
							webviewType === stringConstants.AUTHWEBVIEW ? 'jsCallback' : 'redirectUri',
						exitRedirectUri: getOIDCRedirectURI(config.platform, config.hostApp),
						isGatewayStore,
					};
					Logger.getInstance().write(logConstants.DEBUG, id + ': calling openLoginUrl');
					ctxsNative.openLoginUrl(JSON.stringify(params));
				} else {
					Logger.getInstance().write(logConstants.DEBUG, id + ': calling openChildTab');
					ctxsNative.openChildTab(startUrl, referenceUri, webviewType, '');
				}

				Logger.getInstance().writeAot(AotCategory.Info, 'Closing login page');
			}.bind(this)
		);
	},
};
export default authWebviewHandler;
